import React from 'react';
import {Box, Link, Stack, Typography} from '@mui/material';
import * as MuiIcons from '@mui/icons-material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import {getPicto} from '../../../utils/pictoCatalog.js';
import Constants from '../../../utils/constants';

const formatJour = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR') : null);

/**
 * Une consigne « figée » (forme de `AnomalieDetectionService::snapshotConsignes` et du DTO
 * `InterventionDetail.consignesActives`) : picto, couleur, libellé, détail, validité, plan d'accès.
 * Partagé entre le tiroir Contrôle qualité et la vue intervention v2.
 */
const ConsigneSnapshotRow = ({consigne, dense = false}) => {
    const Picto = MuiIcons[getPicto(consigne.picto).mui] || MuiIcons.Help;
    const couleur = consigne.couleur || '#11285e';
    const validite = [
        consigne.dateDebut ? `du ${formatJour(consigne.dateDebut)}` : null,
        consigne.dateFin ? `au ${formatJour(consigne.dateFin)}` : null,
    ].filter(Boolean).join(' ');
    return (
        <Stack direction="row" spacing={1.5} alignItems="flex-start"
               sx={{p: dense ? 1 : 1.25, borderRadius: 2, border: `1.5px solid ${couleur}`, bgcolor: `${couleur}14`}}>
            <Box sx={{
                width: 36, height: 36, borderRadius: 1.5, bgcolor: couleur, color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none'
            }}>
                <Picto fontSize="small"/>
            </Box>
            <Box sx={{minWidth: 0}}>
                <Typography variant="body2" sx={{fontWeight: 700, color: couleur}}>{consigne.libelle ?? consigne.code}</Typography>
                {consigne.detail && <Typography variant="body2">{consigne.detail}</Typography>}
                {validite && (
                    <Typography variant="caption" color="text.secondary">Valide {validite}</Typography>
                )}
                {consigne.fichierPath && (
                    <Box>
                        <Link href={`${Constants.API_ASSETS_DOCUMENT}/${consigne.fichierPath}`} target="_blank" rel="noopener"
                              variant="body2" sx={{display: 'inline-flex', alignItems: 'center', gap: 0.5}}>
                            <InsertDriveFileIcon fontSize="inherit"/> Plan d'accès
                        </Link>
                    </Box>
                )}
            </Box>
        </Stack>
    );
};

export default ConsigneSnapshotRow;
